
export const API_ENDPOINTS = {
  POST_DATA: `api/v1/datasets/`,
  GET_USER: (userId: string) => `user/${userId}`,
};